
import { FormItemName } from '@src/framework/workbench/drawer/constants';
import { checkIsType } from '@src/framework/workbench/drawer/utils';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { config } from '@framework/workbench/ui/border-style/config';
import { IMultiplyModel } from '@src/slide/domain/ui-model/element-modeles/Interface/multiply-model.interface';
import { IPictureModel } from '@src/slide/domain/ui-model/element-modeles/Interface/picture-model.interface';
import { IItems } from '../form.interface';
import { FORM_CONFIGS as textShadowConfig } from '@src/framework/workbench/drawer/ui/text/effects/shadow/config';
import { FORM_CONFIGS as textReflectionConfig } from '@src/framework/workbench/drawer/ui/text/effects/reflection/config';
import { FORM_CONFIGS as textGlowConfig } from '@src/framework/workbench/drawer/ui/text/effects/glow/config';
import { FORM_CONFIGS as textFillConfig } from '@src/framework/workbench/drawer/ui/text/fill/config';
import { FORM_CONFIGS as textBorderConfig } from '@src/framework/workbench/drawer/ui/text/border/config';
import { FORM_CONFIGS as textTextBoxConfig } from '@src/framework/workbench/drawer/ui/text/text-box/config';

/**
 * 获取multiply-model需要置灰的设置项。
 * @param model 所选元素
 * @returns
 */
export const getMultiDisabledItems = (model: IMultiplyModel): IItems => {
    const isTable = checkIsType(model, UIModelType.TABLE);
    const isConnector = checkIsType(model, UIModelType.CONNECTOR);
    const isAllImage = model.selectedModels.every(model => (model as IPictureModel).isImage?.());
    const hasTable = model.selectedModels.filter(model => model.type === UIModelType.TABLE).length > 0;
    const hasChart = model.selectedModels.filter(model => model.type === UIModelType.CHART).length > 0;

    return {
        [FormItemName.FILL_SELECT]: () => isTable,
        [FormItemName.SOLID_FILL_COLOR]: () => isTable,
        [FormItemName.IMAGE_FILL_CLIPBOARD]: () => isTable,
        [FormItemName.IMAGE_FILL_OPACITY]: () => isTable,
        [FormItemName.IMAGE_FILL_UPLOAD]: () => isTable,
        [FormItemName.IMAGE_FILL_STYLE]: () => isTable,
        [FormItemName.GRADUAL_FILL_ANGLE]: () => isTable,
        [FormItemName.GRADUAL_FILL_DIRECTION]: () => isTable,
        [FormItemName.GRADUAL_FILL_BAR]: () => isTable,
        [FormItemName.GRADUAL_FILL_LINEAR_GRADIENT]: () => isTable,
        [FormItemName.GRADUAL_FILL_RADIAL_GRADIENT]: () => isTable,
        [FormItemName.TABLE_BORDER_COLOR]: () => isTable,
        [FormItemName.TABLE_BORDER_COLOR_TEXT]: () => isTable,
        [FormItemName.LAYOUT_ROTATE]: () => isTable || hasChart,
        [FormItemName.SIZE_ADJUST]: () => true,
        // 多选不支持设置表格边框
        ...getTableBorderItems(model),
        // 所选表格不支持锁定纵横比
        // TODO 连接线暂不支持锁定纵横比
        [FormItemName.SIZE_ADJUST]: () => isConnector || isTable,
        // 幻灯片最佳放映比例，多选时置灰
        [FormItemName.BEST_PLAY_SCALE]: () => true,
        // 幻灯片相对图片原始尺寸，仅都为image时不置灰
        [FormItemName.RELATIVE_IMAGE_ORIGINAL_SIZE]: () => !isAllImage,
        [FormItemName.PICTURE_POSITIOIN_WIDTH]: () => true,
        [FormItemName.PICTURE_POSITIOIN_HEIGHT]: () => true,
        [FormItemName.PICTURE_POSITIOIN_OFFSET_X]: () => true,
        [FormItemName.PICTURE_POSITIOIN_OFFSET_Y]: () => true,
        [FormItemName.CROP_POSITIOIN_WIDTH]: () => true,
        [FormItemName.CROP_POSITIOIN_HEIGHT]: () => true,
        [FormItemName.CROP_POSITIOIN_LEFT]: () => true,
        [FormItemName.CROP_POSITIOIN_TOP]: () => true,
        // 多选表格不支持设置文字相关属性
        ...getTableTextItems(model),
        [FormItemName.FONT_ADJUST]: () => hasTable,
    };
};

const getTableBorderItems = (model: IMultiplyModel): IItems => {
    const itemMap = {};
    const isTable = checkIsType(model, UIModelType.TABLE);
    for (let index = 0; index < 10; index++) {
        itemMap[config.dropdown.data[index].id] = () => isTable;
    }
    return itemMap;
};

const getTableTextItems = (model: IMultiplyModel) => {
    const isTable = checkIsType(model, UIModelType.TABLE);
    // 其实应该还包括字体和段落相关配置项，不过这些配置项和工具栏是通用的
    // 工具栏中的禁用项在 disable-item 中配置，同时侧边栏的中间件也应用了这些配置项，所以在这里不用单独写
    const itemMap = {};
    // 文本框
    textTextBoxConfig.forEach(({ name }) => {
        itemMap[name] = () => isTable;
    });
    // 文字填充
    textFillConfig.forEach(({ name }) => {
        itemMap[name] = () => isTable;
    });
    // 文字边框
    textBorderConfig.forEach(({ name }) => {
        itemMap[name] = () => isTable;
    });
    // 阴影
    textShadowConfig.forEach(({ name }) => {
        itemMap[name] = () => isTable;
    });
    // 映像
    textReflectionConfig.forEach(({ name }) => {
        itemMap[name] = () => isTable;
    });
    // 发光
    textGlowConfig.forEach(({ name }) => {
        itemMap[name] = () => isTable;
    });
    return itemMap;
};
